import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map, takeUntil } from 'rxjs';
import { AddressPayload } from 'src/app/models/addressPayload';
import {
  BagPayload,
  BagResponse,
  UpdatedBagResponse,
  PaymentPaload
} from 'src/app/models/bagResponse';
import { Coupons } from 'src/app/models/coupons';
import { PaymentMode } from '../const/paymentMode.const';

@Injectable({
  providedIn: 'root'
})
export class BagService {
  constructor(private readonly http: HttpClient) {}

  getBaglistData(payload: BagPayload): Observable<BagResponse> {
    return this.http
      .post<{
        data: BagResponse;
      }>(`${environment.base_url}user/getCart`, payload)
      .pipe(map(res => res.data));
  }

  getDashboardCounts(): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.base_url}user/dashboardCounts`)
      .pipe(map(res => res.data));
  }

  productHandlingInBag(
    data: {
      productId: string;
      variantId: string;
      quantity?: number;
      substituteId?: string;
    },
    query: string,
    cartSection?: boolean
  ): Observable<UpdatedBagResponse> {
    let path = 'user/addToCart';
    if (typeof cartSection === 'boolean' && !cartSection) {
      path = 'user/cart/laterCart';
    }
    return this.http
      .post<{
        data: UpdatedBagResponse;
      }>(`${environment.base_url}${path}?${query}`, data)
      .pipe(map(res => res.data));
  }

  productHandlingInSaveForLater(
    data: {
      productId: string;
      variantId: string;
    },
    query: string
  ): Observable<UpdatedBagResponse> {
    return this.http
      .post<{
        data: UpdatedBagResponse;
      }>(`${environment.base_url}user/cart/laterCart?${query}`, data)
      .pipe(map(res => res.data));
  }

  moveToCart(
    data: {
      cartId: string;
    }
  ): Observable<any> {
    console.log('data',data);
    return this.http
      .post<{
        data: any;
      }>(`${environment.base_url}user/cart/move-to-cart`, data)
      .pipe(map(res => res.data));
  }

  moveToSaveForLater(
    data: {
      cartId: string;
    }
  ): Observable<UpdatedBagResponse> {
    return this.http
      .post<{
        data: UpdatedBagResponse;
      }>(`${environment.base_url}user/cart/save-for-later`, data)
      .pipe(map(res => res.data));
  }

  getCouponlistData(query: string): Observable<Coupons[]> {
    return this.http
      .get<{
        data: Coupons[];
      }>(`${environment.base_url}user/getCoupon?${query}`)
      .pipe(map(res => res.data));
  }

  getAddresslistData(): Observable<AddressPayload[]> {
    return this.http
      .get<{
        data: AddressPayload[];
      }>(`${environment.base_url}user/getAddress`)
      .pipe(map(res => res.data));
  }

  addAddress(payload: AddressPayload): Observable<AddressPayload> {
    return this.http
      .post<{
        data: AddressPayload;
      }>(`${environment.base_url}user/addAddress`, payload)
      .pipe(map(res => res.data));
  }

  editAddress(payload: AddressPayload, id: string): Observable<AddressPayload> {
    return this.http
      .put<{
        data: AddressPayload;
      }>(`${environment.base_url}user/editAddress/${id}`, payload)
      .pipe(map(res => res.data));
  }

  clearBagList(): Observable<BagResponse> {
    return this.http
      .delete<{
        data: BagResponse;
      }>(`${environment.base_url}user/deleteCart`)
      .pipe(map(res => res.data));
  }

  deleteAddress(event: string): Observable<BagResponse> {
    return this.http
      .delete<{
        data: BagResponse;
      }>(`${environment.base_url}user/deleteAddress/${event}`)
      .pipe(map(res => res.data));
  }

  payNow(data: PaymentPaload,url: string = `${environment.operational_url}operational/placeOrder`): Observable<BagPayload> {
    // if (data.paymentMode === PaymentMode.CARD && data.paymentMethod == 1) {
    //   url = `${environment.payment_url}operational/placeOrder`;
    // }
    return this.http
      .post<{
        data: BagPayload;
      }>(url, data)
      .pipe(map(res => res.data));
  }

  rechargeWallet(data: any): Observable<any> {
    return this.http
      .post<{
        data: any;
      }>(`${environment.base_url}user/rechargeWallet`, data)
      .pipe(map(res => res.data));
  }

  walletHistory(): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${environment.base_url}user/walletHistory`)
      .pipe(map(res => res.data));
  }

  markAddressAsDefault(address: AddressPayload, callback: () => void): void {
    const body: AddressPayload = {
      addressType: address.addressType,
      houseNo: address.houseNo,
      landMark: address.landMark,
      address: address.address,
      city: address.city,
      state: address.state,
      pincode: address.pincode,
      phoneNo: address.phoneNo,
      country: address.country,
      countryCode: address.countryCode,
      latitude: address.latitude,
      longitude: address.longitude,
      email: address.email,
      name: address.name,
      defaultAddress: true,
    };

    this
      .editAddress(body, address && address._id ? address._id : "")
      .subscribe({
        next: () => {
          callback?.();
        },
        error: () => {
        },
      });
  }
}
